import _ from "underscore";
import update from "immutability-helper";
import React, { Component } from "react";
import { withStyles } from "material-ui/styles";

import { DropTarget } from "react-dnd";
import { fade } from "material-ui/styles/colorManipulator";
import Item from "./Item";
import ItemTypes from "./ItemTypes";
import getDndContext from "../../DndContext";

const styles = {
  addButton: {
    border: "1px dashed gray",
    padding: "0.5rem 1rem",
    marginBottom: ".5rem",
    backgroundColor: "white",
    cursor: "pointer",
    outline: "none",
    "&:hover": {
      backgroundColor: fade("#26a69a", 0.1),
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  }
};

const itemTarget = {
  drop() {}
};

const dropTarget = connect => ({
  connectDropTarget: connect.dropTarget()
});

class Container extends Component {
  constructor(props) {
    super(props);
    this.moveItem = this.moveItem.bind(this);
    this.findItem = this.findItem.bind(this);
    this.state = {
      items: []
    };
  }

  moveItem(id, atIndex) {
    const { item, index } = this.findItem(id);
    // this.props.updateBaseWordItems(item, index, atIndex);
    this.setState(
      update(this.state, {
        items: {
          $splice: [[index, 1], [atIndex, 0, item]]
        }
      })
    );
  }

  findItem(id) {
    // const { items } = this.props.baseWord;
    const { items } = this.state;
    const item = items.filter(c => c.id === id)[0];

    return {
      item,
      index: items.indexOf(item)
    };
  }
  itemsButtons(
    items,
    localeNo,
    changeUseAttrs,
    selectedItemId,
    movable,
    isEdit,
    classes
  ) {
    return (
      <div>
        {items.length > 0 &&
          items.map((item, i) => (
            <Item
              key={item.id}
              id={item.id}
              index={i + 1}
              title={item.locale[localeNo].attrName}
              choices={_.pluck(
                item.locale[localeNo].attrItems,
                "itemName"
              ).join("、")}
              changeUseAttrs={changeUseAttrs}
              isChecked={item.isSelect}
              selectItem={this.props.selectItem}
              moveItem={this.moveItem}
              findItem={this.findItem}
              movable={movable}
              isEdit={isEdit}
              classes={classes}
              preset={!!item.presetFlg}
              dept={!!item.deptFlg}
            />
          ))}
      </div>
    );
  }

  render() {
    const {
      connectDropTarget,
      selectedItemId,
      changeUseAttrs,
      movable,
      items,
      localeNo,
      classes,
      isEdit
    } = this.props;
    return (
      <div>
        {movable && isEdit
          ? connectDropTarget(
              this.itemsButtons(
                items,
                localeNo,
                changeUseAttrs,
                selectedItemId,
                movable,
                isEdit,
                classes
              )
            )
          : this.itemsButtons(
              items,
              localeNo,
              changeUseAttrs,
              selectedItemId,
              movable,
              isEdit,
              classes
            )}
      </div>
    );
  }
}

export default getDndContext()(
  DropTarget(ItemTypes.ITEM, itemTarget, dropTarget)(
    withStyles(styles)(Container)
  )
);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/SelectAttr/Container.jsx